<template>
    <div class="px-md-3 px-2">
        <div class="row  no-gutters mt-md-5 mt-3 font-eng animated fadeIn " style="animation-delay:100ms;">
            <div class="col-md-10 bg-dark  offset-md-1 box  border-line" style="border-radius: 10px">
                <div class="mb-2">
                    <h6 class="text-pink mt-3 pl-md-4 pl-1 silkscreen-regular ">
                        <img style="width: 35px; height: 35px;border-radius: 50%;" src="https://raw.githubusercontent.com/ShineShineDev/ShineShineDev/refs/heads/main/imgs/me.jpg">
                        Shine Htet Aung / >
                        <small class="float-right pr-md-3">
                            <samp class="material-icons text-danger mr-1">circle</samp>
                            <samp class="material-icons text-warning mr-1">circle</samp>
                            <samp class="material-icons text-pink mr-1">circle</samp>
                        </small>
                    </h6>
                </div>
                <div class="shine-divider"></div>
                <div class="row no-gutters pb-4">
                    <div class="col-md-7 col-12">
                        <div class="text-pink px-md-4 px-3 mt-4 animated fadeIn "
                            style="line-height: 25px;text-align: justify;">
                           <div style="color: white;" class="mb-1"> Professional Summary </div>  
                           <p class="px-1">
                            Experienced and detail-oriented software developer with over 4 years of experience in designing, developing, and maintaining scalable web applications. Proficient in a wide range of technologies including JavaScript, Laravel, Nextjs, Angular, React, Vue.js, Node.js, Redis, RabbitMQ, Firebase, Docker. Strong background in building RESTful APIs, database design. Passionate about writing clean, efficient code and delivering high-quality products that solve real-world problems
                           </p>
                     
                            <router-link to="/projects">
                                <button class="btn btn-sm   text-pink animated fadeIn  custom-bg-color"
                                    style="animation-delay:500ms;letter-spacing: 3px;"> Projects
                                    />
                                </button>
                            </router-link>
                            <router-link to="/contact">
                                <button class="btn btn-sm  mt-md-0 mt-2 text-pink animated fadeIn  custom-bg-color ml-md-2"
                                    style="animation-delay:1000ms;letter-spacing: 3px;"> Send
                                    Message />
                                </button>
                            </router-link>
                            <router-link to="/skills">
                                &nbsp;&nbsp; <button style="animation-delay:1200ms;letter-spacing: 3px;"
                                    class="animated fadeIn mt-md-0 mt-2 btn btn-sm custom-bg-color text-pink">Skills</button>
                            </router-link>
                        </div>
                        <div class="mt-md-4 mt-3 px-md-4 pl-3 mb-3   d-flex p-0 m-0 justify-content-start animated fadeIn "
                            style="animation-delay:1500ms;">
                            &nbsp;
                            <div>
                                <a href="tel:+959787796698">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" style="color: #95af04;"
                                        height="24" fill="currentColor" class="bi bi-telephone-outbound-fill mr-4"
                                        viewBox="0 0 16 16">
                                        <path fill-rule="evenodd"
                                            d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                                    </svg>
                                </a>
                            </div>
                            <div>
                                <a href="https://www.linkedin.com/in/shine-shine-dev" target="_blank">
                                    <svg xmlns="http://www.w3.org/2000/svg" style="color: #95af04;" height="24"
                                        fill="currentColor" class="mr-4"
                                        viewBox="0 0 448 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
                                        <path
                                            d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z" />
                                    </svg>
                                </a>
                            </div>
                            <!-- <div>
							<a href="tel:+959787796698">
								<svg class="mr-4" width="24" height="24" xmlns="http://www.w3.org/2000/svg"
									fill="currentColor" style="color: #e0dad7;">
									<path
										d="M12.892 13.745s.427.038.656-.247l.448-.563c.216-.28.738-.458 1.249-.174.676.382 1.55.982 2.149 1.541.33.278.407.688.182 1.121l-.002.009c-.232.408-.541.791-.932 1.148l-.009.006c-.44.367-.946.58-1.487.404l-.01-.014c-.972-.275-3.304-1.464-4.79-2.649-2.431-1.918-4.159-5.082-4.637-6.778l-.015-.01c-.176-.543.039-1.049.404-1.488l.007-.008c.357-.391.739-.701 1.148-.932l.009-.002c.432-.225.842-.149 1.121.182.367.379 1.056 1.291 1.54 2.149.284.51.106 1.033-.173 1.248l-.564.448c-.284.23-.247.657-.247.657s.834 3.156 3.953 3.952zm4.907-2.616c-.167 0-.303-.135-.304-.302-.014-1.83-.564-3.288-1.634-4.332-1.072-1.045-2.427-1.581-4.027-1.592-.168-.001-.303-.138-.301-.306.001-.167.136-.301.303-.301h.002c1.762.012 3.258.606 4.447 1.764 1.19 1.162 1.802 2.765 1.817 4.763.001.167-.133.304-.301.306h-.002zm-1.595-.624h-.007c-.168-.004-.301-.143-.297-.31.024-1.038-.273-1.878-.906-2.569-.63-.689-1.495-1.065-2.645-1.149-.167-.013-.293-.158-.281-.325.013-.167.158-.293.325-.281 1.294.095 2.32.548 3.049 1.345.733.8 1.092 1.807 1.065 2.992-.004.165-.139.297-.303.297zm-1.558-.522c-.161 0-.295-.126-.303-.289-.051-1.03-.537-1.534-1.527-1.588-.168-.009-.296-.152-.287-.319.009-.168.151-.296.319-.287 1.308.07 2.034.819 2.101 2.164.009.167-.12.31-.288.318l-.015.001zm6.817 3.469c-.605 4.877-4.172 5.185-4.83 5.396-.28.09-2.882.737-6.152.524 0 0-2.438 2.94-3.199 3.705-.119.119-.258.167-.352.145-.131-.032-.167-.188-.165-.414l.02-4.016v-.001c-4.762-1.323-4.485-6.295-4.431-8.898.054-2.603.543-4.736 1.996-6.17 2.61-2.364 7.987-2.011 7.987-2.011 4.541.02 6.717 1.387 7.222 1.845 1.675 1.434 2.528 4.867 1.904 9.895zm-.652-11.113c-.597-.548-3.007-2.298-8.375-2.322 0 0-6.33-.382-9.416 2.45-1.718 1.718-2.322 4.231-2.386 7.348-.063 3.118-.146 8.958 5.484 10.542l.006.002-.004 2.416s-.035.979.609 1.179c.779.241 1.236-.502 1.981-1.304.408-.44.971-1.086 1.397-1.58 3.851.322 6.812-.417 7.149-.526.777-.253 5.177-.816 5.893-6.657.738-6.022-.358-9.83-2.338-11.548z" />
								</svg>
							</a>
						</div> -->
                            <div>
                                <a href="https://github.com/ShineShineDev" target="_blank">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                        style="color: #95af04;" class="mr-4 bi bi-github" viewBox="0 0 16 16">
                                        <path
                                            d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27s1.36.09 2 .27c1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8" />
                                    </svg>
                                </a>
                            </div>
                            <div>
                                <a href="https://hub.docker.com/u/spideyshine" target="_blank">
                                    <svg widt="24" height="24" xmlns="http://www.w3.org/2000/svg"
                                        style="color: #95af04;" fill="currentColor" viewBox="0 0 640 512">
                                        <path
                                            d="M349.9 236.3h-66.1v-59.4h66.1v59.4zm0-204.3h-66.1v60.7h66.1V32zm78.2 144.8H362v59.4h66.1v-59.4zm-156.3-72.1h-66.1v60.1h66.1v-60.1zm78.1 0h-66.1v60.1h66.1v-60.1zm276.8 100c-14.4-9.7-47.6-13.2-73.1-8.4-3.3-24-16.7-44.9-41.1-63.7l-14-9.3-9.3 14c-18.4 27.8-23.4 73.6-3.7 103.8-8.7 4.7-25.8 11.1-48.4 10.7H2.4c-8.7 50.8 5.8 116.8 44 162.1 37.1 43.9 92.7 66.2 165.4 66.2 157.4 0 273.9-72.5 328.4-204.2 21.4 .4 67.6 .1 91.3-45.2 1.5-2.5 6.6-13.2 8.5-17.1l-13.3-8.9zm-511.1-27.9h-66v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm-78.1-72.1h-66.1v60.1h66.1v-60.1z" />
                                    </svg>
                                </a>
                            </div>
                            <div>
                                <a href="https://shine-shine-dev.blogspot.com/">
                                    <svg class="ml-4" widt="24" height="24" style="color: #95af04;" fill="currentColor"
                                        target="_blank" xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
                                        <path
                                            d="M162.4 196c4.8-4.9 6.2-5.1 36.4-5.1 27.2 0 28.1 .1 32.1 2.1 5.8 2.9 8.3 7 8.3 13.6 0 5.9-2.4 10-7.6 13.4-2.8 1.8-4.5 1.9-31.1 2.1-16.4 .1-29.5-.2-31.5-.8-10.3-2.9-14.1-17.7-6.6-25.3zm61.4 94.5c-53.9 0-55.8 .2-60.2 4.1-3.5 3.1-5.7 9.4-5.1 13.9 .7 4.7 4.8 10.1 9.2 12 2.2 1 14.1 1.7 56.3 1.2l47.9-.6 9.2-1.5c9-5.1 10.5-17.4 3.1-24.4-5.3-4.7-5-4.7-60.4-4.7zm223.4 130.1c-3.5 28.4-23 50.4-51.1 57.5-7.2 1.8-9.7 1.9-172.9 1.8-157.8 0-165.9-.1-172-1.8-8.4-2.2-15.6-5.5-22.3-10-5.6-3.8-13.9-11.8-17-16.4-3.8-5.6-8.2-15.3-10-22C.1 423 0 420.3 0 256.3 0 93.2 0 89.7 1.8 82.6 8.1 57.9 27.7 39 53 33.4c7.3-1.6 332.1-1.9 340-.3 21.2 4.3 37.9 17.1 47.6 36.4 7.7 15.3 7-1.5 7.3 180.6 .2 115.8 0 164.5-.7 170.5zm-85.4-185.2c-1.1-5-4.2-9.6-7.7-11.5-1.1-.6-8-1.3-15.5-1.7-12.4-.6-13.8-.8-17.8-3.1-6.2-3.6-7.9-7.6-8-18.3 0-20.4-8.5-39.4-25.3-56.5-12-12.2-25.3-20.5-40.6-25.1-3.6-1.1-11.8-1.5-39.2-1.8-42.9-.5-52.5 .4-67.1 6.2-27 10.7-46.3 33.4-53.4 62.4-1.3 5.4-1.6 14.2-1.9 64.3-.4 62.8 0 72.1 4 84.5 9.7 30.7 37.1 53.4 64.6 58.4 9.2 1.7 122.2 2.1 133.7 .5 20.1-2.7 35.9-10.8 50.7-25.9 10.7-10.9 17.4-22.8 21.8-38.5 3.2-10.9 2.9-88.4 1.7-93.9z" />
                                    </svg>
                                </a>
                            </div>
                        </div>
                        <br>
                    </div>
                    <div class="col-md-5 col-12 mt-md-3 mt-3 text-pink pb-4 pl-3 pl-md-5 pb-md-5   ">
                        <ul class="list-group border-0" data-aos="fade-up" data-value="4">
                            <li class="list-group-item skill-hover p-2 bg-dark border-0" style="font-size: 15px;">
                                <span class="material-icons icons-aling mr-3">person</span> Spidey Shine
                            </li>
                            <li class="list-group-item skill-hover p-2 bg-dark border-0" style="font-size: 15px;">
                                <span class="material-icons icons-aling mr-3">brightness_auto</span> {{ age }}
                            </li>
                            <li class="list-group-item skill-hover p-2 mt-1 bg-dark border-0" style="font-size: 15px;">
                                <span class="material-icons icons-aling mr-3">phone</span>
                                <a href="tel:09787796698" class="text-pink"> +959 787 796 698</a>
                            </li>
                            <li class="list-group-item skill-hover p-2 mt-1 bg-dark border-0" style="font-size: 15px;">
                                <span class="material-icons icons-aling mr-3">email</span>
                                <a href="mailto:aungshine194@gmail.com" class="text-pink"> aungshine194@gmail.com</a>
                            </li>
                            <li class="list-group-item skill-hover p-2 mt-1 bg-dark border-0" style="font-size: 15px;">
                                <span class="material-icons icons-aling mr-3">location_on</span>
                                <a href="https://goo.gl/maps/LEnaqGtozwJetNHe7" class="text-pink"
                                    style="text-decoration: none;">
                                   Yangon / Myanmar 
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <img src="https://raw.githubusercontent.com/ShineShineDev/ShineShineDev/55f9002887e4a0cbb513502045b1734b2f2fbe67/imgs/mainIconsdark.svg" class="js-img" />
    </div>
</template>
<script>
import {InitBrowserAgent} from "./../services/detech-visitors.js";
export default {
    name: "Profile",
    data() {
        return {
            age: null,
            text: "Experienced and detail-oriented software developer with over 4 years of experience in designing, developing, and maintaining scalable web applications. Proficient in a wide range of technologies including JavaScript, Laravel, Nextjs, Angular, React, Vue.js, Node.js, Redis, RabbitMQ, Firebase, Docker. Strong background in building RESTful APIs, database design. Passionate about writing clean, efficient code and delivering high-quality products that solve real-world problems.",
            index: 0,
            displayedText: "",
            host: process.env.VUE_APP_HOST,
        }
    },
    created() {
        const {browser,language,platform,innerWidth,innerHeight,URL,visitor_generated__id,is_new_visitor,outerWidth,outerHeight,referrer} = InitBrowserAgent(); 
        this.$store.dispatch('initApi', { url: 'https://bot.okjapanstore.com/api/tg/notify', method: 'POST', data: { Noti: 'Alert',URL,browser,language,platform,innerWidth,innerHeight,visitor_generated__id , is_new_visitor,innerWidth,innerHeight,outerWidth,outerHeight,referrer} });
        const bd = 1999;
        const current_date = new Date().getFullYear();
        this.age = current_date - bd;
    },
    methods: {
        getExperienceYear() {
            const begin = 2018;
            const current_year = new Date().getFullYear();
            return current_year - begin
        },
    },
    mounted() {
        this.intervalId = setInterval(() => {
            this.displayedText = this.text.slice(0, this.index);
            this.index++;
            if (this.index > this.text.length) {
                clearInterval(this.intervalId); // Stop the interval after the text is fully written
            }
        }, 5);
    },
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Silkscreen:wght@400;700&display=swap');

.silkscreen-regular {
    font-family: "Silkscreen", sans-serif;
    font-weight: 400;
    font-style: normal;
}

.text-pink {
    color: rgb(255, 255, 255);
}

.shine-divider {
    margin-top: 5px;
    margin-bottom: 3px;
    border: 0px;
    height: 3px;
    background: linear-gradient(to right, rgba(157, 157, 157, 0), #ec4e10, rgba(0, 0, 0, 0));
    background-size: 200% 100%;
    animation: shineAnimation 1.5s infinite alternate;
}

.border-line {
    border-radius: 50%;
    border-left: 2px solid #FF4A01;
    border-right: 2px solid #FF4A01;
    border-radius: 0 0 20px 20px;
}

.custom-bg-color {
    background-color: #ff4a01;
}

.js-img {
    position: fixed;
    bottom: 0%;
    left: 80%;
   
    width: 400px;
  
}

@keyframes colorChange {
    0% {
        filter: hue-rotate(0deg);
    }

    100% {
        filter: hue-rotate(360deg);
    }
}


@keyframes shineAnimation {
    0% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 0 50%;
    }
}
</style>